import { Suspense } from "react";
import { RoutesPage } from "./routes/routes";
import "./App.scss";
import { Toaster } from "react-hot-toast";
import { QueryClient, QueryClientProvider } from 'react-query';
import { queryClient } from "./utils/common";

function App() {

  return (
    <QueryClientProvider client={queryClient}>
    <div className="App">
      <Suspense fallback={<h4>Loading...</h4>}>
        <RoutesPage />
      </Suspense>
      <Toaster />
    </div>
    </QueryClientProvider>
  );
}

export default App;
